// extracted by mini-css-extract-plugin
module.exports = {"conditions":"bd_fk","conditions__content":"bd_fl","conditions__footer":"bd_fm"};